<div class="overview-section">
    <div class="heading-container">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
    </div>
    <div class="overview-top-section">
        <div class="overview-top-section-left" *ngIf="userDetails?.user">
            <div class="profile-image-container">
                <ng-container *ngIf="profileImage; else noProfileImage">
                    <img class="profile-image" [src]="profileImage" alt="Image preview" />
                </ng-container>
                <ng-template #noProfileImage>
                    <mat-icon class="profile-image-icon">person</mat-icon>
                </ng-template>
                <div class="overlay" [matMenuTriggerFor]="menu" [class.profile-no-image-overlay]="!profileImage">
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="fileInput.click()">Upload</button>
                        <button mat-menu-item (click)="uploadFile($event, '')" *ngIf="profileImage">Remove</button>
                    </mat-menu>
                    <span class="change-photo-text">{{
                        userDetails?.user?.profileImage ? profileLabel.ChangeProfileImage : profileLabel.AddProfileImage
                    }}</span>
                    <mat-icon class="camera-icon">photo_camera</mat-icon>
                </div>
                <input
                    type="file"
                    #fileInput
                    id="image"
                    class="file-input"
                    accept="image/jpeg, image/png, image/webp, image/gif"
                    (change)="uploadFile($event, 'image')"
                />
            </div>
        </div>
        <div class="overview-top-section-right" *ngIf="userDetails?.user">
            <p class="user-name">{{ userDetails?.user?.name }}</p>
            <p class="user-mobile">{{ userDetails?.user?.userMobileNumber }}</p>
            <p class="user-email">{{ userDetails?.user?.email }}</p>
        </div>
        <div *ngIf="!userDetails?.user">
            <app-button variant="hero" (onClick)="clickAddUserDetails()">Add Your Details</app-button>
        </div>
    </div>

    <div class="overview-bottom-section">
        <div class="div1" routerLink="/account/trackOrder">
            <img class="order-icon" src="../../../assets/order-image.png" />
            <div>
                <p class="order-text">Orders</p>
                <p class="order-description">Check your order Status</p>
            </div>
        </div>
        <div class="div2" routerLink="/wishlist">
            <img class="wishlist-icon" src="../../../assets/wishlist-image.png" />
            <div>
                <p class="wishlist-text">Wishlist</p>
                <p class="wishlist-description">All your curated product collection</p>
            </div>
        </div>
        <div class="div3" routerLink="/account/rewards">
            <img class="reward-icon" src="../../../assets/reward-image.png" />
            <div>
                <p class="reward-text">Reward</p>
                <p class="reward-description">Manage all your rewards</p>
            </div>
        </div>
        <div class="div4" routerLink="/account/addressDetails">
            <img class="address-icon" src="../../../assets/address-image.png" />
            <div>
                <p class="address-text">Addresses</p>
                <p class="address-description">Save addresses for your hassale-free delivery</p>
            </div>
        </div>
        <div class="div5">
            <img class="coupon-icon" src="../../../assets/couponn.png" />
            <div>
                <p class="coupon-text">Coupons</p>
                <p class="coupon-description">Manage coupons for additional discounts</p>
            </div>
        </div>
        <div class="div6" routerLink="/account/profileDetails">
            <img class="profile-icon" src="../../../assets/profile-details.jpeg" />
            <div>
                <p class="profile-text">Profile details</p>
                <p class="profile-description">Change your profile Details</p>
            </div>
        </div>
    </div>
</div>
